module.exports = __webpack_public_path__ + "img/blit.0cb48e6d.png";